/**
 * Monta teamData do Board a partir dos 5 blocos da API
 * (mesmo vínculo que loadAreaTeam / loadAreaCoord).
 */
export function assembleBoardTeamData(payload) {
  const technicians = payload?.technicians || [];
  const areas = payload?.areas || [];
  const coordinators = payload?.coordinators || [];
  const areaTeam = payload?.areaTeam || [];
  const areaCoord = payload?.areaCoord || [];

  return {
    tecnicos: technicians.map((tecnico) => {
      const vinculo = areaTeam.find((v) => v.id_tech === tecnico.id);
      return {
        ...tecnico,
        areaId: vinculo ? vinculo.id_area : null,
      };
    }),
    areas: areas.map((area) => {
      const vinculo = areaCoord.find((v) => v.id_area === area.id);
      return {
        ...area,
        coordenadorId: vinculo ? vinculo.id_coordinator : null,
      };
    }),
    coordenadores: coordinators,
  };
}
